import { Profile } from 'oidc-client';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { OfficialVmWithRoles } from '../../../core/models/OfficialVmWithRoles';
import { RouteParams } from '../../../core/models/RouteHelper';
import OfficialTable from './OfficialTable';

interface OwnProps {
    userProfile: Profile;
    onDelete?: (id?: number) => Promise<void>;
    officialsFromProps?: OfficialVmWithRoles[];
    shouldDisplayRolesColumn?: boolean;
    wrappedComponentRef?: any;
    federationId?: number;
    matchId?: number;
    /** When set with matchId + officialsFromProps, Edit opens this instead of navigating to match officials route */
    onMatchOfficialEditFromTable?: (officialId: number) => void;
}

export type Props = OwnProps & RouteComponentProps<RouteParams>;

export default withRouter(OfficialTable);
